import React from "react";
// map 
import Mapir from "mapir-react-component";
import 'mapbox-gl/dist/mapbox-gl.css';
import { Map } from "../../../features/map/mapToken.tsx";
// error
import { onError } from "../../../features/error/error.tsx";
// calendar
// @ts-ignore
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
// datePicker
import { handleChange } from "../../../features/datePicker/datePickerChange.tsx";
// controller
import { Order } from "../../../controllers/orders/order.tsx";


const CreateOrder = () => {
    const { plans, order_id, isLoading, register, handleSubmit, coord, pending, onSubmit, reverseFunction, value, setValue, markerRef, address } = Order()
    return (
        <>
            <section>
                {/* admin page component */}
                <div className={'admin-page-content mb-3 pt-0'}>
                    <div id={'admin-page-form'}>
                        <p className={'fw-bold box-title'}>ایجاد سفارش</p>
                        <div className={'card card-body shadow border-0'}>
                            <form onSubmit={handleSubmit(onSubmit, onError)}>
                                <div className="row align-items-center gy-4">
                                    <div className="col-md-6">
                                        <fieldset className='form-floating'>
                                            <select
                                                className="form-select"
                                                {...register('plan_id', { required: 'فیلد پلن الزامی است' })}
                                            >
                                                {!isLoading ? (
                                                    <>
                                                        {plans?.map((item) => (
                                                            <option selected={order_id == item.id} value={item.id} key={item.id}>
                                                                {item.title}
                                                            </option>
                                                        ))}
                                                    </>
                                                ) : null}
                                            </select>
                                            <label className='form-label'>
                                                انتخاب پلن
                                            </label>
                                        </fieldset>
                                    </div>
                                    <div className="col-md-6">
                                        <fieldset className="w-100">
                                            <DatePicker
                                                value={value}
                                                placeholder={'تاریخ'}
                                                calendar={persian}
                                                locale={persian_fa}
                                                className="w-100"
                                                onChange={(value) => handleChange(value, setValue)}
                                            />
                                        </fieldset>
                                    </div>
                                    <div className="col-md-6 position-relative">
                                        <Mapir center={coord} Map={Map} onClick={reverseFunction}></Mapir>
                                        <div ref={markerRef} className="marker"></div>
                                    </div>
                                    <div className="col-md-6">
                                        <fieldset className='form-floating'>
                                            <textarea
                                                placeholder='آدرس'
                                                className='form-control'
                                                value={address}
                                            />
                                            <label className='form-label'>
                                                آدرس
                                            </label>
                                        </fieldset>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end">
                                    <button disabled={pending} className='btn btn-outline-primary mt-4'>
                                        {pending ? 'در حال ارسال ...' : 'ارسال'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CreateOrder;